import React, { useEffect, useState } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
  createRow,
  type MRT_TableOptions,
} from "material-react-table";
import {
  Box,
  Button,
  IconButton,
  Stack,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import MaterialModal from "../../../components/app/material-modal";


import AddCircleIcon from "@mui/icons-material/AddCircle";
// import scssVars from "../../../../../../scss/variables.module.scss";
import IwMenu from "../../../components/app/IwMenu";
import { MoreVert as MoreVertIcon } from "@mui/icons-material";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { videoLibraryData } from "../../../util/admin/dumyData";
import { inputCommonStyle } from "../../../util/admin/cssCommonStyle";
const buttonStyle = {
  // color: scssVars.mainIconColor,
  // borderColor: scssVars.borderGrey,
  width: 190,
  backgroundColor: "white",
  ":hover": {
    // color: scssVars.mainButtonHighlight,
  },
};

export function ModifyVideoLibraryModal({enableVideoLibrary}) {
  // const [open, setOpen] = React.useState(false);
  // const [videoLibrary, setVideoLibrary] = useState([]);
  // const [inputValue, setInputValue] = useState("");
  // const [editedUrl, setEditedUrl] = useState({});
  const handleOpen = () => window.open('/course-videos', '_blank', 'noopener,noreferrer');;
  // const handleClose = () => setOpen(false);
  // const muiTheme = useTheme();

  // const addVideoLibrary = () => {
  //   const id = videoLibrary.length + 1;
  //   setVideoLibrary([
  //     ...videoLibrary,
  //     {
  //       id,
  //       group: "",
  //       video: [
  //         {
  //           parentId: id,
  //           childId: 1,
  //           title: "",
  //           url: "",
  //         },
  //         { parentId: id, childId: 1, title: "", url: "" },
  //       ],
  //     },
  //   ]);
  // };
  // const handleInputChange = (id, event) => {
  //   const newVideoLibrary = videoLibrary.map((group) => {
  //     if (group.id === id) {
  //       return {
  //         ...group,
  //         group: event.target.value,
  //       };
  //     }
  //     return group;
  //   });
  //   setVideoLibrary(newVideoLibrary);
  // };

  // const handleCreatGroup = async ({ values, table, row }) => {
  //   const parentId = row.original.parentId;

  //   const newVideoLibrary = await videoLibrary.map((group, index) => {
  //     if (group.id === parentId) {
  //       const addVideo = {
  //         parentId,
  //         childId: group.video.length + 1,
  //         ...values,
  //       };
  //       group.video = [...group.video, addVideo];
  //     }
  //     return group;
  //   });
  //   await setVideoLibrary(newVideoLibrary);
  //   table.setCreatingRow(null);
  // };

  // const editGroupChildrenUrlAndTitle = (data) => {
  //   setEditedUrl({});
  // };

  // const data = React.useMemo(() => videoLibraryData, []);

  // const columns = React.useMemo(
  //   () => [
  //     {
  //       header: "TITLE",
  //       accessorKey: "title",
  //       muiEditTextFieldProps: ({ cell, row }) => ({
  //         onChange: (event) =>
  //           setEditedUrl((prevState) => ({
  //             ...prevState,
  //             [row.original.parentId]: {
  //               ...prevState[row.original.parentId],
  //               title: event.target.value,
  //             },
  //           })),
  //       }),
  //     },
  //     {
  //       header: "URL",
  //       accessorKey: "url",
  //       muiEditTextFieldProps: ({ cell, row }) => ({
  //         onChange: (event) =>
  //           setEditedUrl((prevState) => ({
  //             ...prevState,
  //             [row.original.parentId]: {
  //               ...prevState[row.original.parentId],
  //               url: event.target.value,
  //             },
  //           })),
  //       }),
  //     },
  //   ],
  //   []
  // );

  // useEffect(() => {}, [videoLibrary, handleInputChange]);

  return (
    <Box sx={{ width: "100%" }}>
      <Button variant="contained" onClick={handleOpen} disabled={!enableVideoLibrary}>
        Modify Video Library
      </Button>
      {/* <MaterialModal
        open={open}
        handleDialogClose={handleClose}
        styleOverrides={{
          container: {
            "& .MuiDialog-paper": {
              width: "100%",
              minHeight: "500px",
              minWidth: "800px",
              ".MuiDialogContent-root": {
                overflow: "auto",
              },
            },
          },
        }}
        title="Video Library"
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box>
          <Stack
            direction="row"
            gap={3}
            sx={{
              width: "300px",
              height: "auto",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <Typography fontWeight={700}>Videos</Typography>
            <Box sx={{ flexBasis: "40%" }}>
              <Button
                variant="outlined"
                sx={buttonStyle}
                onClick={addVideoLibrary}
              >
                <AddCircleIcon
                  sx={{
                    marginRight: "4px",
                    fontSize: "24px",
                    color: muiTheme.palette.primary.main,
                    opacity: 1,
                  }}
                />
                Create Group
              </Button>
            </Box>
            <Box>
              <Button variant="outlined" sx={buttonStyle} onClick={handleOpen}>
                <AddCircleIcon
                  sx={{
                    marginRight: "4px",
                    fontSize: "24px",
                    color: muiTheme.palette.primary.main,
                    opacity: 1,
                  }}
                />
                Add Default Videos
              </Button>
            </Box>
          </Stack>

          {videoLibrary.map((videoGroup, index) => {
            return (
              <Box key={`group-${index}`}>
                <MaterialReactTable
                  columns={columns}
                  data={videoGroup.video}
                  enableFullScreenToggle={false}
                  enableHiding={false}
                  enableGlobalFilter={false}
                  enableDensityToggle={false}
                  enableColumnActions={false}
                  enableColumnFilters={false}
                  enablePagination={false}
                  enableSorting={false}
                  createDisplayMode={"row"}
                  editDisplayMode={"table"}
                  enableEditing={true}
                  enableRowActions={true}
                  positionActionsColumn={"last"}
                  getRowId={(row) => row.childId}
                  onCreatingRowSave={handleCreatGroup}
                  renderRowActions={({ row }) => (
                    <IwMenu
                      label={<MoreVertIcon fontSize="large" />}
                      tooltipProps={{
                        title: "Options",
                      }}
                      triggerComponentSx={{
                        margin: "0 8px",
                        padding: "2px 0",
                      }}
                      items={[
                        {
                          id: "save",
                          label: "save",
                          onClick: () => {
                            editGroupChildrenUrlAndTitle(row.original);
                          },
                        },
                        {
                          id: "delete",
                          label: "Delete",
                          onClick: () => {},
                        },
                      ]}
                    />
                  )}
                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "16px",
                        padding: "8px",
                        alignItems: "center",
                      }}
                    >
                      <Stack direction="row" gap={2}>
                        <Typography sx={{ fontSize: "16px", color: "#626262" }}>
                          Group:
                        </Typography>
                        <TextField
                          id="outlined-basic"
                          variant="outlined"
                          size="small"
                          defaultValue={videoGroup.group}
                          sx={inputCommonStyle}
                          onChange={(event) =>
                            handleInputChange(videoGroup.id, event)
                          }
                        />
                      </Stack>
                      <Button
                        variant="outlined"
                        sx={buttonStyle}
                        onClick={() => {
                          table.setCreatingRow(
                            createRow(table, {
                              parentId: videoGroup.id,
                            })
                          );
                        }}
                      >
                        <AddCircleIcon
                          sx={{
                            marginRight: "4px",
                            fontSize: "24px",
                            color: muiTheme.palette.primary.main,
                            opacity: 1,
                          }}
                        />
                        Add Row
                      </Button>
                    </Box>
                  )}
                />
              </Box>
            );
          })}
        </Box>
      </MaterialModal> */}
    </Box>
  );
}
